// libs
import React, { memo, useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

// store
import { fetchAllImagesFromCustomerReview } from 'shared/store/details/services';

// components
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import ImageGallery from 'shared/components/ReviewCard/ImageGallary';
import ImageRail from './components/ImageRail';
import ImageGridGallery from './components/ImageGridGallery';
import {
  getAllReviewImages,
  getImageRelatedReviewData,
  getLastImageFetchedKey,
} from 'shared/store/details/selectors';

// styles
import { OverlaySheet, BuyerPhotosText } from './styles';

// analytics
import { trackReviewImgClick } from 'shared/components/ReviewCard/analytics';

export enum IMAGE_VIEW_TYPE {
  RAIL,
  GALLERY,
}

const BUYER_PHOTOS = 'Buyer Photos';

interface IReviewAllImages {
  viewType: IMAGE_VIEW_TYPE;
  isMobile?: boolean;
}

function ReviewAllImages({ viewType = IMAGE_VIEW_TYPE.RAIL, isMobile = true }: IReviewAllImages) {
  const imageList = useSelector(getAllReviewImages),
    pageKey = useSelector(getLastImageFetchedKey),
    imageRelatedReview = useSelector(getImageRelatedReviewData);
  const dispatch = useDispatch();
  const [selectedReviewIndex, setSelectedReviewIndex] = useState(-1);

  const { id: prdId } = useParams<{ id: string }>();

  const OnOverLayHide = () => setSelectedReviewIndex(-1);

  const handleImageClick = ({ index }: ReviewAllImages.IImageClickCallBack) => {
    trackReviewImgClick();
    setSelectedReviewIndex(Number(index));
  };

  const handleImageClickFromImageGrid = ({ index }: ReviewAllImages.IImageClickCallBack) => {
    trackReviewImgClick();
    setSelectedReviewIndex(Number(index));
  };

  // call image fetching api for first load
  useEffect(() => {
    if (pageKey === '') {
      isMobile && dispatch(fetchAllImagesFromCustomerReview({ productId: prdId }));
    }
  }, [dispatch, isMobile, pageKey, prdId]);

  if (!isMobile) return null;

  return (
    <>
      {viewType === IMAGE_VIEW_TYPE.RAIL && imageList.length > 0 && (
        <>
          <BuyerPhotosText>{BUYER_PHOTOS}</BuyerPhotosText>
          <ImageRail handleClick={handleImageClick} />
        </>
      )}

      {viewType === IMAGE_VIEW_TYPE.GALLERY && (
        <ImageGridGallery handleClick={handleImageClickFromImageGrid} />
      )}

      {selectedReviewIndex !== -1 && (
        <OverlaySheet
          navKey="imageViewer_rail"
          transitionFrom={SHEET_TRANSITION.RIGHT}
          onHide={OnOverLayHide}
        >
          <ImageGallery
            images={imageList}
            reviews={imageRelatedReview}
            activeIndex={selectedReviewIndex}
          />
        </OverlaySheet>
      )}
    </>
  );
}

export default memo(ReviewAllImages);
